import React from 'react'

import FormTextArea from "../../../../core/gd-form/form-element/textarea/textarea"

type Props = {
    url: string
}

export default function EmbedCode(props:Props) {

    const _getCode = () => '<iframe src="'+props.url+'"/>'

    const onClickCopy = () => {
        gd.utils.copyToClipboard(_getCode());
        gd.growl.success("Code copied to clipboard")
    }

    return (
        <div className="embed-code">
            <FormTextArea value={_getCode()} noResizeControl={true} autosize={true}/>
            <div className="copy-button ui5-link-small" onClick={onClickCopy}>Copy code</div>
        </div>
    )
}